const getLabel = label => label || '-';

export default getLabel;
